import React from "react";
import { TextField, ClassNameMap } from "@mui/material";

import { DateTimePicker } from "@mui/x-date-pickers";

import { CalendarOrClockPickerView } from "@mui/x-date-pickers/internals/models";
import { Controller } from "react-hook-form";

import { withStyles } from "@mui/styles";
import {
  alpha,
  Theme
} from "@mui/material/styles";

import { commonErrorParameters } from "./fields";

interface ZPlayDateTimePickerState{
  value?:Date
}

interface ZPlayDateTimePickerProps
{
  name: string,
  label: string,
  value?: Date,
  control: any,
  trigger: any,
  formState: any,
  disabled?: boolean,
  required?: boolean,

  minDate?: Date,
  maxDate?: Date,
  minTime?: Date,
  maxTime?: Date,
  minDateTime?: Date,
  maxDateTime?: Date,
  minutesStep?: number,
  views?: CalendarOrClockPickerView[],
  classes: ClassNameMap<"root">,
  openTo?: CalendarOrClockPickerView,
  showTodayButton?: boolean,
  todayText?: React.ReactNode,
  cancelText?: React.ReactNode,
}

const styles = (theme: Theme) => ({
	root: {
		"& .MuiFilledInput-root": {
			overflow: "hidden",
			borderRadius: "0px",
			backgroundColor: "#FFFFFF",
			transition: theme.transitions.create([
				"border-color",
				"background-color",
				"box-shadow",
			]),
			"&:hover": {backgroundColor: "#FFFFFF",},
			"&.Mui-focused": {
				backgroundColor: "#FFFFFF",
				boxShadow: `${alpha("#000000", 0.25)} 0 0 0 2px`,
				borderColor: "#000000",
			}
		}
	}
});

class ZPlayDateTimePicker extends React.Component<ZPlayDateTimePickerProps, ZPlayDateTimePickerState>
{
  static defaultProps = {
    disabled: false,
    required: false,
    variant: "standard",

    showTodayButton: false,
    todayText: "Today",
    cancelText: "Cancel",
    minutesStep: 1,

    views: undefined,
    openTo: "day"
  }

	componentDidMount(){
		this.setState(() => ({
			value : this.props.value
		}))
	}

  render()
  {
    const {classes} = this.props;

    return (
      <Controller
        name={this.props.name}
        control={this.props.control}
        defaultValue={this.state?.value || this.props.value || new Date()}
        render={({ field }) => (
          <DateTimePicker
            {...field}
            mask="__/__/____ __:__:__"
            inputFormat="dd/MM/yyyy HH:mm:ss"
            ampm={false}
            value={this.state?.value || this.props.value}
            minDate={this.props.minDate}
            maxDate={this.props.maxDate}
            minTime={this.props.minTime}
            maxTime={this.props.maxTime}
            minDateTime={this.props.minDateTime}
            maxDateTime={this.props.maxDateTime}
            minutesStep={this.props.minutesStep}
            openTo={this.props.openTo}
            showTodayButton={this.props.showTodayButton}
            todayText={this.props.todayText}
            cancelText={this.props.cancelText}
            label={this.props.label}
            disabled={this.props.disabled || this.props.formState.isSubmitting}
            onChange={(value) => {
              field.onChange(value)
              this.setState(() => ({
                value : value!
              }))
              this.props.trigger(this.props.name)
            }}
            renderInput={(params) =>
              <TextField
                {...field}
                {...params}
                className={classes.root}
                size="small"
					      margin="dense"
                fullWidth
                required={this.props.required}
                disabled={this.props.disabled || this.props.formState.isSubmitting}
                variant={"filled"}
                name={this.props.name}
                {...commonErrorParameters(this.props.name, this.props.formState)} />
            }
          />
        )}
      />
    )
  }
}

export default withStyles(styles)(ZPlayDateTimePicker);